import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Layout, Avatar, Dropdown, Button, Space } from 'antd';
import { UserOutlined, LogoutOutlined, LoginOutlined } from '@ant-design/icons';
import { getUserInfo, removeToken, removeUserInfo, getToken } from '../utils/auth';
import { useI18n } from '../i18n/I18nContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import SiteFooter from '../components/SiteFooter';
import logo from '../assets/images/logo.png';
import './MainLayout.css';

const { Header, Content, Footer } = Layout;

function MainLayout() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const user = getUserInfo();
  const isLoggedIn = !!getToken();

  const handleLogout = () => {
    removeToken();
    removeUserInfo();
    navigate('/');
    window.location.reload(); // 刷新页面更新状态
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'profile',
      label: t('layout.profile'),
      icon: <UserOutlined />,
      onClick: () => navigate('/profile'),
    },
    {
      key: 'logout',
      label: t('layout.logout'),
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="main-layout">
      <Header className="main-header">
        <div className="logo" onClick={() => navigate('/')}>
          <img className="logo-image" src={logo} alt="logo" />
          {t('appTitle')}
        </div>
        <div className="header-right">
          <Space size="middle">
            <LanguageSwitcher size="middle" />
            {isLoggedIn ? (
              <>
                <span className="welcome-text">
                  {t('layout.welcome', { name: user?.name || user?.username || '' })}
                </span>
                <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                  <Avatar size={40} icon={<UserOutlined />} className="user-avatar" />
                </Dropdown>
              </>
            ) : (
              <Button
                type="primary"
                icon={<LoginOutlined />}
                onClick={handleLogin}
              >
                {t('layout.loginRegister')}
              </Button>
            )}
          </Space>
        </div>
      </Header>
      <Content className="main-content">
        <Outlet />
      </Content>
      <Footer className="main-footer">
        <SiteFooter variant="default" />
      </Footer>
    </Layout>
  );
}

export default MainLayout;
